import { Component, OnInit, Input, inject } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Match } from '../../_shared/models/match.model';
import { AuthService } from '../../auth/auth.service';

@Component({
  standalone: false,
    selector: 'app-tracker-popover',
    templateUrl: './tracker-popover.component.html',
    styleUrls: ['./tracker-popover.component.scss']
})
export class TrackerPopoverComponent implements OnInit {
    private authService = inject(AuthService);
    private popoverCtrl = inject(PopoverController);

    @Input() match: Match;
    @Input() isSuspended: boolean;
    @Input() isOwner: boolean;
    @Input() isTracker: boolean;

    isEditable = true;

    ngOnInit() {
        this.checkMatchStatus();
    }

    dismiss(action) {
        this.popoverCtrl.dismiss(action);
    }

    checkMatchStatus() {
        if (this.match.matchStatus === 'COMPLETED' || this.match.matchStatus === 'RETIRED') {
            this.isEditable = false;
        }
    }

    getWeatherInfo() {
        let temp = this.match.weather?.main.temp;
        let tempUnit = 'C';

        if (this.authService.authUserSignal()?.settings.unit === 'imperial') {
            temp = temp * 9 / 5 + 32;
            tempUnit = 'F';
        }
        return `${temp.toFixed(0)}${tempUnit}`;
    }

}
